// extracted by mini-css-extract-plugin
module.exports = {"wizardTextarea":"_3bkmKuwTtWaMrX9iBBVNh6","desc_text":"_1d4kf7YZmH4jKnTEeReSC3"};